import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, Clock, Download, RefreshCw, Calendar } from 'lucide-react';
const features = [{
  icon: PlayCircle,
  title: 'Acceso ilimitado',
  desc: 'Mirá las clases las veces que necesites, sin restricciones.'
}, {
  icon: Clock,
  title: 'A tu ritmo',
  desc: 'Estudiá cuando puedas: noches, fines de semana, cuando quieras.'
}, {
  icon: Download,
  title: 'Material descargable',
  desc: 'PDFs, planillas y recursos para llevarte a la obra.'
}, {
  icon: RefreshCw,
  title: 'Repasá cuando quieras',
  desc: 'Volvé a los conceptos clave todas las veces que haga falta.'
}];
export function RecordedClasses() {
  return <section id="grabadas" className="py-24 bg-ed-darker relative border-t border-white/5 overflow-hidden" data-id="element-446">
      <div className="absolute inset-0 bg-radial-green-center opacity-20 pointer-events-none" data-id="element-447"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-448">
        <div className="text-center mb-14 max-w-2xl mx-auto" data-id="element-449">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ed-green/10 border border-ed-green/30 mb-5" data-id="element-450">
            <Calendar className="w-4 h-4 text-ed-green" data-id="element-451" />
            <span className="text-xs font-bold tracking-widest text-ed-green uppercase" data-id="element-452">
              Sin presión de horarios
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-5" data-id="element-453">
            ¿No podés estar <span className="text-ed-green" data-id="element-454">en vivo?</span>
          </h2>
          <p className="text-zinc-400 text-lg leading-relaxed" data-id="element-455">
            No hay problema. Todas las clases quedan grabadas para que puedas
            verlas cuando quieras y las veces que necesites.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-456">
          {features.map((f, i) => {
          const Icon = f.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-ed-dark border border-zinc-800 rounded-2xl p-6 hover:border-ed-green/40 transition-all group" data-id="element-457">
                <div className="w-12 h-12 rounded-xl bg-ed-green/10 border border-ed-green/30 flex items-center justify-center mb-4 group-hover:glow-green-sm transition-all" data-id="element-458">
                  <Icon className="w-5 h-5 text-ed-green" data-id="element-459" />
                </div>
                <h3 className="text-white font-black uppercase text-sm tracking-wide mb-2" data-id="element-460">
                  {f.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-461">
                  {f.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}